<template>
  <a-modal :title="$t('message.txtManagement.createPush')" :visible="visible" :confirm-loading="confirmLoading"
    @cancel="visible = false" :afterClose="afterClose" :footer="null" width="1000px">
    <div class="modal-body">
      <div class="modal-body-left">
        <a-tabs v-model="tabKey" style="overflow:unset" :animated="false">
          <a-tab-pane :key="contentChannel.getValueByLabel('SMS')" :tab="$t('message.txtManagement.sms')">
            <sms-and-app-push-temp channel="SMS" ref="smsAndAppPushTempRef" v-if="visible"></sms-and-app-push-temp>
          </a-tab-pane>
          <a-tab-pane :key="contentChannel.getValueByLabel('Email')" :tab="$t('message.txtManagement.email')">
            <email-push-temp channel="Email" ref="emailPushTempRef" v-if="visible"></email-push-temp>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="modal-body-right">
        <a-divider type="vertical" style="float: left;height: 100%;margin-top:15px" />
        <div style="width: 100%;height:852px;position: relative">
          <preview-box :previewItem="previewItem" :hasMask="false"></preview-box>
        </div>
      </div>
    </div>
    <a-divider></a-divider>
    <div class="modal-footer">
      <a-button :size="$globalSize" @click="submit(0)" :loading="loading">{{ $t('message.commonUsage.save')
        }}</a-button>
      <!-- <a-button  :size="$globalSize"  type="primary" @click="submit(1)" v-if="tabKey === '2'">保存并审核</a-button> -->
    </div>
  </a-modal>
</template>
<script>
import utils from "@/utils";
import SmsAndAppPushTemp from "@/views/material/components/SmsAndAppPushTemp";
import EmailPushTemp from "@/views/material/components/EmailPushTemp";
import contentListService from "@/interface/pages/TxtManagement/contentListService";
import previewBox from "@/views/material/components/previewBox";
import EnterpriseWechatPushTemp from "@/views/material/components/EnterpriseWechatPushTemp";
import { contentChannel } from "../../../utils/constant";
export default {
  name: "createPush",
  components: {
    SmsAndAppPushTemp,
    EmailPushTemp,
    EnterpriseWechatPushTemp,
    previewBox
  },
  props: {},
  provide() {
    return {
      changePreviewItem: this.changePreviewItem
    }
  },
  data() {
    return {
      contentChannel,
      visible: false,
      confirmLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      tabKey: '2',
      previewItem: {},
      loading: false
    };
  },
  mounted() {
    utils.languageChange(this, { labelCol: 8, wrapperCol: 16 }, { labelCol: 6, wrapperCol: 16 })
  },
  computed: {},
  watch: {},
  methods: {
    changePreviewItem(obj) {
      this.previewItem = { ...obj }
    },
    showModal() {
      this.tabKey = contentChannel.getValueByLabel('SMS')
      this.visible = true;
    },
    async submit(type) {
      this.loading = true
      let ref
      switch (this.tabKey) {
        case contentChannel.getValueByLabel('SMS'):
          ref = this.$refs.smsAndAppPushTempRef
          break;
        case contentChannel.getValueByLabel('Email'):
          ref = this.$refs.emailPushTempRef
          break;
        default:
          break;
      }
      let formData = {}
      try {
         formData = await ref.formValidate();
        if (!formData) {
          this.loading = false;
          return;
        }
        // ...
      } catch (error) {
        console.error('表单验证出错:', error);
        this.loading = false;
        return;
      }
      let data = {
        ...formData,
      }
      let func = contentListService.addContent
      if (this.tabKey === contentChannel.getValueByLabel('SMS')) {
        data = {
          loginId: localStorage.getItem('userId'),
          contentName: formData.content_name,
          content: formData.content,
          link: formData.link,
          channelId: this.tabKey,
        }
      }
      if (this.tabKey === contentChannel.getValueByLabel('Email')) {
        data = {
          loginId: localStorage.getItem('userId'),
          contentName: formData.content_name,
          content: formData.content,
          templateId: formData.template_id,
          channelId: this.tabKey,
          contentValue: formData.contentValue,
          subject: formData.subject
        }
        func = contentListService.addEmailContent
      }
      const { data: res } = await func(this, { data })
      try {
        if (res.code === '200') {
          this.$message.success(res.message)
          this.$store.dispatch('fetchButtonPermission')
          this.$emit('refresh')
          this.visible = false
        } else {
          this.$message.error(res.message)
        }
        this.loading = false
      } catch (e) {
        console.log(e)
        this.loading = false
      }
    },
    afterClose() {
    },
  },
};
</script>

<style scoped lang="less">
.modal-body {
  display: flex;
  width: 100%;

  .modal-body-left {
    max-width: 530px; 
    flex: 1;
  }

  .modal-body-right {
    flex-shrink: 0;
    width: 450px;
    margin-top: 43px;
    border-top: 1px solid #e8e8e8;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  grid-gap: 10px;
}
</style>
